var _defs, _rect, _g, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHubImagesMobile1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 833.33 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#805eb5;}.cls-2,.cls-7{opacity:0.75;}.cls-3{opacity:0.3;}.cls-4{fill:#dd67ff;}.cls-5{fill:#b754ea;}.cls-6{fill:#d77af9;}.cls-7{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-8{opacity:0.5;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.34,
    width: 834,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "552.31 432.17 497.71 463.7 443.12 432.17 497.71 400.65 552.31 432.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.71,526.74v-63l-54.59-31.53v59.7a5.79,5.79,0,0,0,2.89,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.31,432.17l-54.6,31.53v63l50.91-29.39a7.38,7.38,0,0,0,3.69-6.38Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "556.07 415.91 497.71 449.61 439.36 415.91 497.71 382.22 556.07 415.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "497.71 517 497.71 449.61 439.36 415.91 439.36 483.3 497.71 517"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "556.07 415.91 497.71 449.61 497.71 517 556.07 483.3 556.07 415.91"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 469.22,
    y1: 466.94,
    x2: 353.99,
    y2: 532.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 526.48,
    y1: 466.94,
    x2: 641.71,
    y2: 532.69
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.66 541.78 308.07 573.3 253.47 541.78 308.07 510.25 362.66 541.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,636.34v-63l-54.6-31.52V602a5,5,0,0,0,2.49,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.66,541.78,308.07,573.3v63l51.78-29.9a5.6,5.6,0,0,0,2.81-4.86Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "366.42 525.52 308.07 559.21 249.71 525.52 308.07 491.82 366.42 525.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.07 626.6 308.07 559.21 249.71 525.52 249.71 592.9 308.07 626.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "366.42 525.52 308.07 559.21 308.07 626.6 366.42 592.9 366.42 525.52"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "741.94 541.78 687.34 573.3 632.75 541.78 687.34 510.25 741.94 541.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.34,636.34v-63l-54.59-31.52v58.67a7.58,7.58,0,0,0,3.78,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.94,541.78l-54.6,31.52v63l51.42-29.68a6.39,6.39,0,0,0,3.18-5.51Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "745.7 525.52 687.34 559.21 628.99 525.52 687.34 491.82 745.7 525.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "687.34 626.6 687.34 559.21 628.99 525.52 628.99 592.9 687.34 626.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "745.7 525.52 687.34 559.21 687.34 626.6 745.7 592.9 745.7 525.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 338.44,
    y1: 577.13,
    x2: 453.66,
    y2: 642.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 657.57,
    y1: 576.16,
    x2: 542.34,
    y2: 641.91
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "552.31 651.21 497.71 682.74 443.12 651.21 497.71 619.69 552.31 651.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.71,745.78v-63l-54.59-31.53v58.24a8.33,8.33,0,0,0,4.17,7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.31,651.21l-54.6,31.53v63l50.72-29.28a7.77,7.77,0,0,0,3.88-6.72Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "556.07 634.95 497.71 668.65 439.36 634.95 497.71 601.26 556.07 634.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "497.71 736.03 497.71 668.65 439.36 634.95 439.36 702.34 497.71 736.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "556.07 634.95 497.71 668.65 497.71 736.03 556.07 702.34 556.07 634.95"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -69.63,
    y: -22.45,
    width: 1157.5,
    height: 1111.45,
    rx: 40.66
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubImagesMobile1);
export default __webpack_public_path__ + "static/media/HubImagesMobile1.7dbf396da96a6ad31c4ac24c0a51a346.svg";
export { ForwardRef as ReactComponent };